import { render, staticRenderFns } from "./FornecedorGestaoGruposListagem.vue?vue&type=template&id=326b7029&"
import script from "./FornecedorGestaoGruposListagem.vue?vue&type=script&lang=js&"
export * from "./FornecedorGestaoGruposListagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports